import React from 'react';

const Modal = ({ show, onClose, onOption1, onOption2 }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className='p_close' onClick={onClose}><i className="bi bi-x"></i></button>
                <h4>Who is Signing up</h4>
                <div className='d-flex justify-content-center align-items-center'>
                    <button className='btn_option' onClick={onOption1}>
                        <img src='../images/icon-buyer.png' />
                        Buyer
                    </button>
                    <span className="or_seprator">OR</span>
                    <button className='btn_option' onClick={onOption2}>
                        <img src='../images/icon-artist.png' />
                        Artist / Reseller
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;